import React, { ReactNode } from 'react';

import { Box, Center } from '@chakra-ui/react';

import { TrashIcon } from 'components/Icons';

interface AttributeIconButtonProps {
  icon: ReactNode;
  onClick: () => void;
  isDisabled?: boolean;
  color?: string;
}

export const AttributeIconButton = (props: AttributeIconButtonProps) => {
  const { icon, onClick, isDisabled, color = 'critical' } = props;

  return (
    <Box
      boxSize={5}
      flexShrink={0}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      onClick={() => !isDisabled && onClick()}
    >
      <Center color={color} opacity={isDisabled ? 0.5 : 1}>
        {icon}
      </Center>
    </Box>
  );
};

interface DeleteAttributeIconButtonProps
  extends Omit<AttributeIconButtonProps, 'icon' | 'color'> {}

export const DeleteAttributeIconButton = (
  props: DeleteAttributeIconButtonProps,
) => <AttributeIconButton {...props} icon={<TrashIcon />} />;
